"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _launcherBase = require("../util/launcherBase");

var _accessibility = require("../util/accessibility");

var _keyCodes = require("../util/keyCodes");

var _tooltipPositioner = _interopRequireDefault(require("./tooltipPositioner"));

var _TooltipBody = _interopRequireDefault(require("./TooltipBody"));

var TOOLTIP_WRAPPER_CLASS = 'tooltip-dest';

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Tooltip, _React$Component);

  function Tooltip(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Tooltip);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Tooltip).call(this, props));
    _this.state = {
      tooltipShown: _this.props.initialShown,
      tooltipOpen: true,
      tooltipAnimating: false,
      positioningRequested: false,
      posObj: {
        left: null,
        top: null
      }
    };
    _this._handlePositioningRequest = _this._handlePositioningRequest.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.toggleShown = _this.toggleShown.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.onLauncherClick = _this.onLauncherClick.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.hideTooltip = _this.hideTooltip.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this._handleClick = _this._handleClick.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this._resizePosition = _this._resizePosition.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this._handleKeyPress = _this._handleKeyPress.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this._positionTooltip = _this._positionTooltip.bind((0, _assertThisInitialized2["default"])((0, _assertThisInitialized2["default"])(_this)));
    _this.launcherRef = null;
    return _this;
  }

  (0, _createClass2["default"])(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.initialShown) {
        this._positionTooltip();
      }
      /*eslint-disable react/no-did-mount-set-state */


      this.setState({
        tooltipAnimating: true,
        tooltipOpen: this.props.initialShown
      });
      /*eslint-enable react/no-did-mount-set-state*/

      /*
          HDP-11684: used mouseup for desktop and touchend for both android/iphone as mouseup is not supported
          HDP-14071: add "closeOnStart" option for closing the tooltip on "touchstart" and "mousedown" events.
          The default is for "mouseup" and "touchend" events to close the tooltip.
       */

      if (this.props.closeOnStart) {
        window.addEventListener('mousedown', this._handleClick); // this event listener needs to have passive:false in order to allow e.preventDefault()
        // to be called for 'touchstart' events. See Chrome docs for more:
        // https://www.chromestatus.com/features/5093566007214080

        window.addEventListener('touchstart', this._handleClick, {
          passive: false
        });
      } else {
        window.addEventListener('mouseup', this._handleClick);
        window.addEventListener('touchend', this._handleClick);
      }

      window.addEventListener('resize', this._resizePosition);
      window.addEventListener('keydown', this._handleKeyPress);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderTooltipBody();
    } // from zsg-launcher-base
    // TODO refactor into more react-friendly approach

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('mousedown', this._handleClick);
      window.removeEventListener('touchstart', this._handleClick);
      window.removeEventListener('mouseup', this._handleClick);
      window.removeEventListener('touchend', this._handleClick);
      window.removeEventListener('resize', this._resizePosition);
      window.removeEventListener('keydown', this._handleKeyPress); // Clean up external tooltips

      if (typeof document !== 'undefined') {
        var externalBody = document.getElementById(this.props.id);

        if (externalBody) {
          // sometimes YUI nukes the tree before we get here,
          // so let's avoid passing `undefined` here
          _reactDom["default"].unmountComponentAtNode(externalBody);
        }
      }

      window.clearTimeout(this.hideCallback);
    }
  }, {
    key: "_resizePosition",
    value: function _resizePosition() {
      // Waiting 100ms for resize to complete so styles can be recalculated.
      // TODO Something like Y.after('resize') would be useful here
      if (this.state.tooltipOpen) {
        window.setTimeout(this._positionTooltip, 100);
      }
    } // Because positioning is DOM-dependent, set a flag and disabled animation
    // for position calculation. When the tooltip has updated, the _handlePositioningRequest
    // will be called as a callback to position the tooltip and reset the flag.

  }, {
    key: "requestPositioning",
    value: function requestPositioning() {
      this.setState({
        positioningRequested: true,
        tooltipAnimating: false
      });
    }
  }, {
    key: "_handlePositioningRequest",
    value: function _handlePositioningRequest() {
      if (this.state.positioningRequested) {
        this._positionTooltip(); // Ensure that the tooltip has had a frame to move to the repositioned location
        // before animating the opening


        if (this.state.posObj.left !== null) {
          this.setState({
            positioningRequested: false,
            tooltipAnimating: true
          });
        }
      }
    }
  }, {
    key: "_positionTooltip",
    value: function _positionTooltip() {
      if (typeof document === 'undefined') {
        return;
      }

      var launchNode = this.launcherRef,
          contentNode = document.getElementById(this.props.id).children[0],
          viewportNode = (0, _launcherBase.getWrapperElement)(this.launcherRef),
          posObj = _tooltipPositioner["default"]._calculateOptimalPosition(contentNode, launchNode, viewportNode, this.props.placement),
          parentRect = viewportNode.getBoundingClientRect(); // Fix up properties relative to containers
      // TODO refactor _calculateOptimalPosition to return data formatted correctly


      posObj.left = posObj.x - parentRect.left + 'px';
      posObj.top = posObj.y - parentRect.top + 'px';

      if (posObj.arrow.left) {
        posObj.arrowLeft = posObj.arrow.left + 'px';
      }

      if (posObj.arrow.top) {
        posObj.arrowTop = posObj.arrow.top + 'px';
      }

      posObj.transform = posObj.arrow.transform;
      this.setState({
        posObj: posObj
      });
    } // While a tooltip is open, clicks outside of the tooltip should close it

  }, {
    key: "_handleClick",
    value: function _handleClick(e) {
      if ('clientX' in e || 'changedTouches' in e) {
        var tooltipElem = document.getElementById(this.props.id),
            tooltipbody = tooltipElem && tooltipElem.children && tooltipElem.children[0],
            launchNode = this.launcherRef; // `mouseup` events will have clientX and clientY coordinates, and `touchend` events
        // will have a changedTouches array with 1 element containing the coordinates.

        var point = {};

        if (typeof e.clientX !== 'undefined') {
          point.clientX = e.clientX;
          point.clientY = e.clientY;
        } else if (e.changedTouches[0] && typeof e.changedTouches[0].clientX !== 'undefined') {
          point.clientX = e.changedTouches[0].clientX;
          point.clientY = e.changedTouches[0].clientY;
        } // HDP-14071: Prevent the page from scrolling when a tooltip is open, and the user touches/clicks
        // the tooltip. The following check is done for cases when "closeOnStart" is true, typically
        // for double-scroll layouts. It also checks that the user did not click on link, in order to
        // still allow links to work in tooltips.


        if (this.state.tooltipShown && this.props.closeOnStart && (0, _launcherBase.rectContainsPoint)(tooltipbody.getBoundingClientRect(), point) && e.target && e.target.tagName && e.target.tagName.toLowerCase() !== 'a') {
          e.preventDefault();
        }

        if (this.state.tooltipShown && !(0, _launcherBase.rectContainsPoint)(tooltipbody.getBoundingClientRect(), point) && !(0, _launcherBase.rectContainsPoint)(launchNode.getBoundingClientRect(), point)) {
          this.hideTooltip();
        }
      }
    }
  }, {
    key: "_handleKeyPress",
    value: function _handleKeyPress(e) {
      // Escape key closes tooltips
      if (e.keyCode === _keyCodes.ESC_KEY) {
        e.stopPropagation();
        this.hideTooltip();
      }
    }
  }, {
    key: "onLauncherClick",
    value: function onLauncherClick(e) {
      this.props.onClick(e);
      this.toggleShown();
    }
  }, {
    key: "toggleShown",
    value: function toggleShown() {
      if (this.state.tooltipShown) {
        this.hideTooltip();
      } else {
        this.showTooltip();
      }
    } // Hide tooltip by removing the shown class, and then removing the open
    // class after the animation completes

  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      var _this2 = this;

      this.setState({
        tooltipShown: false
      });
      this.hideCallback = window.setTimeout(function () {
        _this2.setState({
          tooltipOpen: false
        });
      }, 150);
    } // Show the tooltip by setting the open class, positioning, and then
    // setting the shown class after the next animation frame.

  }, {
    key: "showTooltip",
    value: function showTooltip() {
      var _this3 = this;

      this.setState({
        tooltipOpen: true
      }, function () {
        var cb = function cb() {
          return _this3.setState({
            tooltipShown: true
          });
        };

        (0, _launcherBase.callAfterNextAnimationFrame)(cb);
      });
      this.requestPositioning();
    } // Tooltips must live at top level for z-index and margin considerations.
    // Because of this, they must be rendered manually. This render method
    // creates the DOM elements necessary at the wrapper level and then
    // renders the tooltips.

  }, {
    key: "renderTooltipBody",
    value: function renderTooltipBody() {
      if (typeof document === 'undefined') {
        return;
      }

      var ExternalTooltip = _react["default"].createElement(_TooltipBody["default"], {
        animating: this.state.tooltipAnimating,
        shown: this.state.tooltipShown,
        open: this.state.tooltipOpen,
        top: this.state.posObj.top,
        left: this.state.posObj.left,
        placement: this.state.posObj.placement,
        onClose: this.hideTooltip,
        arrowLeft: this.state.posObj.arrowLeft,
        arrowTop: this.state.posObj.arrowTop,
        transform: this.state.posObj.transform,
        updatedFn: this._handlePositioningRequest
      }, this.props.children);

      var wrapper = (0, _launcherBase.getWrapperElement)(this.launcherRef);
      var element; // ZM-14013: Make sure the tooltip and tooltip destination both have the same
      // wrapper as it is possible for a single wrapper to contain multiple
      // destinations.

      var destinations = wrapper.querySelectorAll("." + TOOLTIP_WRAPPER_CLASS);

      for (var i = 0; i < destinations.length; i += 1) {
        if (wrapper === (0, _launcherBase.getWrapperElement)(destinations[i])) {
          element = destinations[i];
          break;
        }
      }

      if (!element) {
        element = document.createElement('div');
        element.className = TOOLTIP_WRAPPER_CLASS;
        wrapper.appendChild(element);
      }

      var tooltipbody = document.getElementById(this.props.id);

      if (!tooltipbody) {
        tooltipbody = document.createElement('div');
        tooltipbody.id = this.props.id;
        element.appendChild(tooltipbody);
      }

      _reactDom["default"].render(ExternalTooltip, tooltipbody);
    } // Renders only the launcher as the direct DOM representation of this element

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var launcherAttrs = {
        onClick: this.onLauncherClick,
        onKeyDown: function onKeyDown(e) {
          if ((0, _accessibility.shouldTriggerButton)(e.keyCode)) {
            // Don't move the page down (seen when hitting the space bar), when using the keypress event to toggle the tooltip
            e.preventDefault();

            _this4.toggleShown();
          }
        },
        ref: function ref(element) {
          _this4.launcherRef = element;
        },
        tabIndex: 0,
        role: 'button'
      };

      if (this.props.launcher && this.props.svg) {
        return _react["default"].createElement("tspan", launcherAttrs, this.props.launcher);
      } else if (typeof this.props.launcher === 'string') {
        // Underline launcher
        return _react["default"].createElement("span", (0, _extends2["default"])({}, launcherAttrs, {
          style: {
            cursor: 'help',
            whiteSpace: 'nowrap'
          },
          className: "zsg-tooltip-launch_keyword"
        }), this.props.launcher);
      } else if (this.props.launcher) {
        return _react["default"].createElement("span", launcherAttrs, this.props.launcher);
      }

      return _react["default"].createElement("a", (0, _extends2["default"])({}, launcherAttrs, {
        className: "zsg-icon-circle-question zsg-icon_clickable"
      }));
    }
  }]);
  return Tooltip;
}(_react["default"].Component);

exports["default"] = Tooltip;
Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  id: _propTypes["default"].string.isRequired,

  /**
   *  Tooltip content node
   */
  children: _propTypes["default"].node,
  initialShown: _propTypes["default"].bool,

  /**
   *  Node that opens tooltip.
   *  - If a string, uses the underline launcher style.
   *  - If a node, uses whatever is in the node.
   *  - If undefined, uses the standard circle-question zsg icon.
   */
  launcher: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),

  /**
   * Will render the launcher inside a <tspan>
   */
  svg: _propTypes["default"].bool,

  /**
   * Specify position for the tooltip
   */
  placement: _propTypes["default"].oneOf(['right', 'left', 'bottom', 'top']),

  /**
   * Click handler for if the caller needs something to happen
   * when the tooltip launcher is clicked
   */
  onClick: _propTypes["default"].func,

  /**
   * Boolean value that specifies whether the tooltip
   * should be closed on touchstart and mousedown.
   * Defaults to false.
   */
  closeOnStart: _propTypes["default"].bool
} : {};
Tooltip.defaultProps = {
  initialShown: false,
  onClick: function onClick() {}
};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Tooltip/index.js
// module id = 502
// module chunks = 0